import React from 'react';
import { cn } from 'lib/utils';

// Latin (with accents) and Cyrillic letters plus digits; the ES5 target rules out \p{L}.
const ALNUM = /[0-9A-Za-zÀ-ɏЀ-ӿ]/g;
const alnum = (word: string): string => (word.match(ALNUM) ?? []).join('');

/**
 * Two characters for a group's tile. Class names lead with their grade and keep
 * it ("9-B sinf" → "9B", "10-A sinf" → "10"); other names take the first letter
 * of their first two words ("DTM kechki guruh" → "DK"), a single word its first two.
 */
export function groupMonogram(name: string): string {
  const words = (name || '').split(/\s+/).map(alnum).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1 || /^[0-9]/.test(words[0])) return words.join('').slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

interface GroupTileProps {
  name: string;
  /** Size overrides (the default is the 40px card tile). */
  className?: string;
}

/** A group's neutral monogram square — no team colour. */
export function GroupTile({ name, className }: GroupTileProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-muted text-[13px] font-bold text-foreground/80',
        className,
      )}
    >
      {groupMonogram(name)}
    </span>
  );
}

export default GroupTile;
